/* global Homie */
import AuthenticationRoutes from '../../shared/routes/authentication';
import PageNotFound from '../../shared/components/PageNotFound';
import Init from '../../onboarding/Init';
import PreRegistration from '../../onboarding/pre_registration/pre_registration.vue';
import Presentation from '../../onboarding/process_steps/Presentation';

let beforeEnterPreRegistration = (to, from, next) => {
  if(Homie.is_logged && Homie.user.mobile_phone) {
    return next({name: 'auth.term'});
  }
  next();
};

let routes = [
  { path: '/', component: Init },
  { path: '/presentation', component: Presentation, name: 'presentation', meta: {requiredAuth: true} },
  { path: '/pre-registration', component: PreRegistration, name: 'pre_registration', beforeEnter: beforeEnterPreRegistration },
  { path: "*", component: PageNotFound }
].concat(AuthenticationRoutes);

export default routes